import ResetPassword from 'features/Authentication/ResetPassword';

function ResetPasswordPage() {
  return <ResetPassword />;
}

export default ResetPasswordPage;
